// removed by extract-text-webpack-plugin
module.exports = {"questionWrapper":"_8pOjalPfqke-EXpOo9wGD","actionIcon":"_2Z7ayC5xzYkpLKCMgZrphB","question":"_16ZCgWvK25l8cYSYDI28-X","answer":"_2eX6yuqAg0uAJeZQG1js5x","opened":"_2NTbhT5deiZwpRpeqbBqCa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQItem/FAQItem.scss
// module id = 1600
// module chunks = 0